import { render, staticRenderFns } from "./CommentRow.vue?vue&type=template&id=0db9c03c&scoped=true&"
import script from "./CommentRow.vue?vue&type=script&lang=ts&"
export * from "./CommentRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db9c03c",
  null
  
)

export default component.exports